/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Button } from '@micromag/core/components';
import { Text as TextField } from '@micromag/fields';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';

import { copyTextToClipboard } from '../../lib/utils';

const propTypes = {
    title: PropTypes.string,
    url: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    title: null,
    url: null,
    className: null,
};

const PublicationEmbedForm = ({ title, url, className }) => {
    const [width, setWidth] = useState(320);
    const [height, setHeight] = useState(480);

    const onWidthChange = useCallback(
        (e) => {
            const w = parseInt(e, 10) || 0;
            setWidth(w);
            setHeight(w * 2);
        },
        [setWidth, setHeight],
    );

    const copyString = `<iframe title="${title}" url="${url}" width="${width}" height="${height}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="true"></iframe>`;

    const onCopy = useCallback(() => {
        copyTextToClipboard(copyString);
    }, [copyString]);

    return (
        <form className={classNames(['form-inline', { [className]: className !== null }])}>
            <div className="form-group mb-2">
                <label htmlFor="string" className="me-2 ">
                    <FormattedMessage defaultMessage="Code" description="Field label" />
                </label>
                <TextField
                    id="string"
                    value={copyString}
                    type="text"
                    className="me-2"
                    onChange={null}
                    autofocus
                />
                <div className="d-flex">
                    <Button
                        onClick={onCopy}
                        icon={<FontAwesomeIcon icon={faCopy} color="currentColor" />}
                    >
                        <FormattedMessage
                            defaultMessage="Copy the code"
                            description="Field label"
                        />
                    </Button>
                </div>
            </div>
            <div className="form-group mb-2">
                <label htmlFor="width" className="me-2 ">
                    <FormattedMessage defaultMessage="Width" description="Field label" />
                </label>
                <TextField
                    id="width"
                    value={width}
                    type="number"
                    className="me-2"
                    onChange={onWidthChange}
                />
                <label htmlFor="height" className="me-2">
                    <FormattedMessage defaultMessage="Height" description="Field label" />
                </label>
                <TextField id="height" value={height} type="number" disabled />
            </div>
        </form>
    );
};

PublicationEmbedForm.propTypes = propTypes;
PublicationEmbedForm.defaultProps = defaultProps;

export default PublicationEmbedForm;
